import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationRU from './locales/ru/translation.json';
import translationFR from './locales/fr/translation.json';

const resources = {
  en: {
    translation: translationEN
  },
  ru: {
    translation: translationRU
  },
  fr: {
    translation: translationFR
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Keys or params to look for language
      lookupLocalStorage: 'i18nextLng',
      // Cache user language on localStorage
      caches: ['localStorage'],
      // Only detect languages that are in the whitelist
      checkWhitelist: true
    },
    whitelist: ['en', 'ru', 'fr'],
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
